import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
var _templateObject, _templateObject2, _templateObject3;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import styled from 'styled-components';
import HeroDashboard from '../../dashboard/HeroDashboard';
import Block from './../../Block';
import { toBreakpoint } from '../../../styles/breakpoints';
import { connect } from 'react-redux';
import { GridWrapper, GridItem } from '../../../styles/gridElements';
import { getResultData, invalidateApiDataRequest, getApiDataRequest } from '../../../redux/apiData';
import isLastItem from '../../../services/isLastItem';
import get from 'lodash.get';
import withMatch from '@/hocs/withMatch';
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    redirect: get(state, 'redirect'),
    resultWishList: getResultData(state.apiData, 'postWishList', {
      projectSlug: String(ownProps.match.params.projectSlug)
    }),
    notificationsRequest: getApiDataRequest(state.apiData, 'getNotifications', {
      projectSlug: String(ownProps.match.params.projectSlug)
    }),
    settings: getResultData(state.apiData, 'getSettings', {
      projectSlug: String(ownProps.match.params.projectSlug),
      env: String(ownProps.match.params.env)
    })
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    invalidateNotifications: function invalidateNotifications(projectSlug) {
      dispatch(invalidateApiDataRequest('getNotifications', {
        projectSlug: String(projectSlug)
      }));
    }
  };
};
var LayoutDashboard = /*#__PURE__*/function (_Component) {
  function LayoutDashboard() {
    _classCallCheck(this, LayoutDashboard);
    return _callSuper(this, LayoutDashboard, arguments);
  }
  _inherits(LayoutDashboard, _Component);
  return _createClass(LayoutDashboard, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        match = _this$props.match,
        notificationsRequest = _this$props.notificationsRequest,
        invalidateNotifications = _this$props.invalidateNotifications;
      var projectSlug = match.params.projectSlug;

      // If more than 30 seconds have passed since the last time we retrieved notifications, get them again
      if (notificationsRequest && projectSlug && Date.now() - notificationsRequest.lastCall > 30000) {
        invalidateNotifications(projectSlug);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        page = _this$props2.page,
        renderWidth = _this$props2.renderWidth;
      return __jsx("div", {
        "data-e2e-page-layout": "dashboard",
        "data-id": "layout_LayoutDashboard_div"
      }, page.templateProps && __jsx(HeroDashboard, _extends({}, page.templateProps, {
        renderWidth: renderWidth,
        "data-id": "layout_LayoutDashboard_HeroDashboard"
      })), __jsx(DashboardGridWrapper, {
        "data-id": "layout_LayoutDashboard_DashboardGridWrapper"
      }, (page.blocks || []).map(function (block, index) {
        return __jsx(BlockCell, {
          key: index,
          "data-id": "layout_LayoutDashboard_BlockCell"
        }, __jsx(Block, {
          block: block,
          renderWidth: renderWidth,
          isLastItem: isLastItem(page.blocks, index),
          "data-id": "layout_LayoutDashboard_Block"
        }));
      })));
    }
  }]);
}(Component);
var DashboardGridWrapper = styled(GridWrapper)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  z-index: 3;\n"])));
var BlockCell = styled(GridItem)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  padding-top: 30rem;\n  padding-bottom: 30rem;\n\n  ", ";\n"])), toBreakpoint.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    padding-right: 10rem;\n    padding-left: 10rem;\n  "]))));
export default withMatch(connect(mapStateToProps, mapDispatchToProps)(LayoutDashboard));